<template>
    <div :class="[classes.menuServicesExpansionPanel.mobile, classes.menuServicesExpansionPanel.tabletLandscape]">
        <!-- Post Production Category -->
        <div
            class="post-production flex flex-col mobile:mb-6 tabletLandscape:mx-4 tabletLandscape:w-1/2 pl-6">
            <!--Service Items in Category-->
            <inertia-link
                :href="route(serviceCategories.postProduction.routeName)"
                class="transition-all duration-200 hover:scale-95"
            >
                <div
                    class="w-full mobile:flex mobile:items-center flex items-center">
                    <svg-icon
                        :icon="serviceCategories.postProduction.icon"
                        class="inline-block mr-4 mobile:w-12 mobile:h-12 mobile:mb-2 tabletLandscape:w-24 tabletLandscape:h-24" />
                    <p
                        class="inline-block max-w-tiny mobile:text-xs mobile:w-24 mobile:ml-4 text-white text-sm uppercase tracking-widest break-words">
                        {{ serviceCategories.postProduction.categoryLabel }}
                    </p>
                </div>
            </inertia-link>
        </div>

        <!-- Photography Category-->
        <div
            class="photography flex flex-col mobile:pl-6 tabletLandscape:mr-12 tabletLandscape:w-1/2 tabletLandscape:border-l border-gray-600 border-dashed tabletLandscape:pl-12">
            <!--Service Items in Category-->
            <a
                :href="serviceCategories.photography.externalUrl"
                target="_blank"
                class="transition-all duration-200 hover:scale-95"
            >
                <div
                    class="w-full mobile:flex mobile:items-center flex items-center">
                    <svg-icon
                        :icon="serviceCategories.photography.icon"
                        class="inline-block mr-4 mobile:w-12 mobile:h-12 mobile:mb-2 tabletLandscape:w-24 tabletLandscape:h-24" />
                    <p
                        class="inline-block max-w-xs mobile:text-xs mobile:w-24 mobile:ml-4 text-white text-sm uppercase tracking-widest">
                        {{ serviceCategories.photography.categoryLabel }}
                    </p>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@whisper/components/icons/SvgIcon';

export default {
  name: 'MenuExpansionPanel',
  components: { SvgIcon },
  props: {
    serviceCategories: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    classes: {
      menuServicesExpansionPanel: {
        mobile: [
          'shadow-2xl',
          'rounded-b',
          'bg-black-900',
          'flex',
          'flex-col',
          'mobile:border-l',
          'mobile:border-gold-500',
          'mobile:ml-6',
          'justify-start',
        ],
        tabletLandscape: [
          'tabletLandscape:absolute',
          'tabletLandscape:flex-row',
          'tabletLandscape:w-full',
          'tabletLandscape:py-10',
          'tabletLandscape:top-16',
          'tabletLandscape:left-0',
          'tabletLandscape:bg-black-900',
        ],
      },
    },
  }),
};
</script>
<style>
    .postProdSeparator {
        max-width: 8rem;
    }
    .photogServiceItem:last-child {
        border-bottom: none;
    }
</style>
